import { cleanupReservedRegExpSymbols } from "./textUtils";

export const splitMatch = (fullName: string, term: string) => {
  const termSegments = cleanupReservedRegExpSymbols(term).split(/\s+/);
  return fullName.split(/\s+/).flatMap((nameSegment, i) => {
    const termSearch = termSegments.length > 1 ? termSegments[i] : termSegments[0];

    return nameSegment.search(new RegExp(`^${termSearch}`, "i")) >= 0
      ? [
          {
            text: nameSegment.slice(0, termSearch.length),
            isHighlighted: true,
          },
          {
            text: nameSegment.slice(termSearch.length) + " ",
            isHighlighted: false,
          },
        ]
      : [{ text: nameSegment + " ", isHighlighted: false }];
  });
};

export default splitMatch;
